export default __webpack_public_path__ + "static/media/logo.9fc42ee8.svg";